import { ContextState, MutationClass } from '../../../models';

export class ClearModuleMutation implements MutationClass {

  public static execute(state: ContextState): void {
    Object.assign(state, {
      instanceId: undefined,
      domain: undefined,
      filters: {},
      query: undefined
    });
  }

}
